import React, { useState } from "react"
import * as common from "./common"
import { yellow } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const BusinessRole = (props) => {
    const { x, y, height, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = yellow[200]
    const defaultColor = fillColor || yellow[100]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    const roleHeight = 5

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <rect
                x={x + 1}
                y={y + 1}
                fill={fill}
                stroke={common.outlineColor}
                width={width - 1}
                height={height - 1}
            />

            <svg x={x + width - 23} y={y + 3} width={6} height={20}>
                <ellipse
                    cx={5}
                    cy={8}
                    rx={4}
                    ry={roleHeight}
                    fill='none'
                    stroke={common.outlineColor}
                />
            </svg>
            <svg x={x + width - 23} y={y + 3} width={20} height={20}>
                <ellipse
                    cx={15}
                    cy={8}
                    rx={4}
                    ry={roleHeight}
                    fill='none'
                    stroke={common.outlineColor}
                />
                <line x1={4} y1={3} x2={15} y2={3} stroke={common.outlineColor} />
                <line x1={4} y1={13} x2={15} y2={13} stroke={common.outlineColor} />
            </svg>

            <ElementText {...props} label={label} />
        </Svg>
    )
}

export default BusinessRole
